import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import ButtonDownload from '../components/PropertiesPaneButtonDownload.jsx'
import ButtonUpload from './PropertiesPaneButtonUpload.jsx'
import Model from './ModelDoc.mjs'

const PropertiesPaneDoc = (props) => (
    <PropertiesPane
        buttons={
            <>
                <ButtonDownload />
                <ButtonUpload />
            </>
        }

        controllers={
            <Text prop="text" />
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPaneDoc
